<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
  <p [innerHTML]="data.html"></p>
</div>
<div mat-dialog-actions>
  <button class="btn btn-primary" (click)="confirmAction()">Ok</button>
</div>
